import React, { FunctionComponent } from 'react';

import { Payment } from '../../requests/caipirinha-api/interfaces/order.interface';
import { toBRL } from '../../utils/money.util';

interface Props {
  payments: Payment[];
  hasSimulated?: boolean;
}

const OrderTotal: FunctionComponent<Props> = ({ payments, hasSimulated = false }) => {
  return (
    <div className="details" data-cy='order-total'>
      <p className="big">{hasSimulated ? 'Valor do pedido' : 'Total'}</p>
      {payments.map(payment => (
        <div key={payment.id} className="metainfo">
          <strong>{toBRL(payment.amount)}</strong>
          <span>
            {payment.installments > 1 && !hasSimulated
              ? `${payment.installments}X ${toBRL(
                  payment.amount / payment.installments,
                )}`
              : ''}
          </span>
        </div>
      ))}
    </div>
  );
};

export default OrderTotal;
